class MobileNavbar {
  constructor() {
    this.navbar = document.getElementById('navbar')
    this.hamburger = document.getElementById('hamburger')
    this.mobileMenu = document.getElementById('mobile-menu')
    this.isMenuOpen = false
    this.init()
  }

  init() {
    // Hamburger menu toggle
    this.hamburger.addEventListener('click', () => this.toggleMenu())

    // Close menu when clicking on links
    this.mobileMenu.addEventListener('click', (e) => {
      if (e.target.tagName === 'A') {
        this.closeMenu()
      }
    })

    // Close menu on window resize if desktop
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768) { // md breakpoint
        this.closeMenu()
      }
    })

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
      if (this.isMenuOpen
        && !this.hamburger.contains(e.target)
        && !this.mobileMenu.contains(e.target)) {
        this.closeMenu()
      }
    })
  }

  toggleMenu() {
    if (this.isMenuOpen) {
      this.closeMenu()
    }
    else {
      this.openMenu()
    }
  }

  openMenu() {
    this.isMenuOpen = true
    this.hamburger.classList.add('hamburger-active')
    this.mobileMenu.classList.add('open')
    // Prevent scrolling when menu is open
    document.body.style.overflow = 'hidden'
  }

  closeMenu() {
    this.isMenuOpen = false
    this.hamburger.classList.remove('hamburger-active')
    this.mobileMenu.classList.remove('open')
    // Restore scrolling
    document.body.style.overflow = ''
  }
}

new MobileNavbar()

class AspectRatioController {
  constructor(elementId, options = {}) {
    this.element = document.getElementById(elementId)
    if (this.element) {
      this.aspectRatio = options.aspectRatio || (9 / 16) // 9:16 ratio
      this.maxWidth = options.maxWidth || 375
      this.maxHeightVh = options.maxHeightVh || 'calc(100svh - 9rem)'

      this.resizeObserver = null
      this.init()
    }
  }

  init() {
    // Initial sizing
    this.updateDimensions()

    // Listen for window resize
    window.addEventListener('resize', () => this.updateDimensions())

    // Listen for changes using ResizeObserver
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateDimensions()
      })
      this.resizeObserver.observe(this.element)
    }

    // Use MutationObserver to catch style/class changes
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes'
          && (mutation.attributeName === 'style' || mutation.attributeName === 'class')) {
          // Delay slightly to ensure styles are applied
          setTimeout(() => this.updateDimensions(), 10)
        }
      })
    })

    mutationObserver.observe(this.element, {
      attributes: true,
      attributeFilter: ['style', 'class'],
    })
  }

  calculateMaxHeight() {
    // Convert CSS calc() to actual pixels
    const testDiv = document.createElement('div')
    testDiv.style.height = this.maxHeightVh
    testDiv.style.position = 'absolute'
    testDiv.style.visibility = 'hidden'
    document.body.appendChild(testDiv)
    const maxHeight = testDiv.offsetHeight
    document.body.removeChild(testDiv)
    return maxHeight
  }

  updateDimensions() {
    if (!this.element) return

    const computedStyle = window.getComputedStyle(this.element)
    const position = computedStyle.position

    // Get the container width (respecting max-width)
    let containerWidth
    if (position === 'fixed') {
      // When fixed, use viewport width but respect max-width
      containerWidth = Math.min(window.innerWidth - 32, this.maxWidth) // 32px for padding
    }
    else {
      // When not fixed, use parent container width
      const parent = this.element.parentElement
      const parentRect = parent.getBoundingClientRect()
      containerWidth = Math.min(parentRect.width - 32, this.maxWidth)
    }

    // Calculate height based on aspect ratio
    let calculatedHeight = containerWidth / this.aspectRatio

    // Get max height constraint
    const maxHeight = this.calculateMaxHeight()

    let finalWidth = containerWidth
    let finalHeight = calculatedHeight

    // If calculated height exceeds max height, adjust width
    if (calculatedHeight > maxHeight) {
      finalHeight = maxHeight
      finalWidth = finalHeight * this.aspectRatio

      // Ensure width doesn't exceed max width
      if (finalWidth > this.maxWidth) {
        finalWidth = this.maxWidth
        finalHeight = finalWidth / this.aspectRatio
      }
    }

    // Apply dimensions
    this.element.style.width = `${finalWidth}px`
    this.element.style.height = `${finalHeight}px`
  }

  // Public method to manually trigger update
  refresh() {
    this.updateDimensions()
  }

  // Cleanup method
  destroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
    window.removeEventListener('resize', this.updateDimensions)
  }
}

new AspectRatioController('shopping-cart', {
  aspectRatio: 9 / 16,
  maxWidth: 375,
  maxHeightVh: 'calc(100svh - 9rem)',
})
